(function () {
  var el = document.querySelector('[data-parallax="testimonial-decorative-image"]');
  if (!el) return;

  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  var distance = parseFloat(el.getAttribute('data-parallax-distance')) || 350;

  gsap.to(el, {
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 1
    },
    x: distance
  });
})();
